module.exports = __webpack_public_path__ + "img/howto-1.5acc90cf.png";